const LoadingSpinner = ({
  size = 'md',
  color = 'emerald',
  className = '',
  label = 'Loading...'
}) => {
  const sizes = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-2',
    lg: 'w-12 h-12 border-3',
    xl: 'w-16 h-16 border-4'
  };

  const colors = {
    emerald: 'border-emerald-600 border-t-transparent',
    white: 'border-white border-t-transparent',
    stone: 'border-stone-600 border-t-transparent',
    blue: 'border-blue-600 border-t-transparent'
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`} role="status">
      <div
        className={`rounded-full animate-spin ${sizes[size]} ${colors[color]}`}
        aria-hidden="true"
      />
      <span className="sr-only">{label}</span>
    </div>
  );
};

// Full-page loading overlay
export const PageLoader = ({ message = 'Loading...' }) => (
  <div className="fixed inset-0 bg-white/80 backdrop-blur-sm flex flex-col items-center justify-center z-50">
    <LoadingSpinner size="lg" />
    <p className="mt-4 text-stone-600 font-medium">{message}</p>
  </div>
);

// Inline loading for sections
export const SectionLoader = ({ className = '' }) => (
  <div className={`flex items-center justify-center py-8 ${className}`}>
    <LoadingSpinner size="md" />
  </div>
);

// Button loading spinner (smaller, white)
export const ButtonSpinner = () => (
  <LoadingSpinner size="sm" color="white" className="mr-2" />
);

export default LoadingSpinner;
